import AnimatedIcon from '../components/AnimatedIcon.jsx';
import AnimatedWrapper from '../components/AnimatedWrapper.jsx';

const pillars = [
  {
    title: 'Ethics in every interaction',
    copy:
      'We champion privacy-first data practices, transparent consent, and responsible AI. Our team maps every touchpoint to ensure insights elevate staff and guests without compromising humanity.',
    icon: 'ethics',
  },
  {
    title: 'Art + Tech = Delight',
    copy:
      'Sculptors, lighting designers, and creative coders collaborate with system engineers to deliver responsive art that doubles as business infrastructure. Expect installations that look gallery-ready while quietly managing your ops.',
    icon: 'delight',
  },
  {
    title: 'Community-minded partnerships',
    copy:
      'We reinvest in local makers across the West Coast, prioritizing inclusive hiring and education programs that help communities thrive alongside the technology.',
    icon: 'community',
  },
];

const About = () => {
  return (
    <div className="page about-page">
      <AnimatedWrapper direction="up" delay={0}>
        <section className="section-heading">
          <p className="eyebrow">Community-built, future-ready</p>
          <h1>Rooted in Ocean Beach, crafting ethical connections everywhere</h1>
          <p>
            TapptiQ started as a collective of artists, technologists, and neighborhood advocates designing installations and part of other local business ventures
            for the local community. We believe connection is more than bandwidth—it&apos;s the trust between people, devices, and the
            communities they serve.
          </p>
        </section>
      </AnimatedWrapper>
      <section className="about-grid">
        {pillars.map((pillar, i) => (
          <AnimatedWrapper key={pillar.title} direction="up" staggerIndex={i} staggerDelay={120}>
            <article>
              <span className="about-icon" aria-hidden="true">
                <AnimatedIcon name={pillar.icon} />
              </span>
              <h2>{pillar.title}</h2>
              <p>{pillar.copy}</p>
            </article>
          </AnimatedWrapper>
        ))}
      </section>
      <AnimatedWrapper direction="up" delay={pillars.length * 120}>
        <section className="callout">
        <h2>Let&apos;s create brighter, kinder experiences</h2>
        <p>
          From San Diego local shops to Seattle innovation labs, we build connected ecosystems that celebrate place, culture, and
          the people who power them.
        </p>
      </section>
      </AnimatedWrapper>
    </div>
  );
};

export default About;
